var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"d-flex"},[_c('span',{class:{
        'visually-hidden': !_vm.isLoading,
        'spinner-border spinner-border-sm col align-self-center mx-2': _vm.isLoading,
      },attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(" "),(_vm.icon)?_c('BS-Icon',{attrs:{"_class":[
        _vm.icon,
        'col',
        'order-' + (_vm.iconOrientation === 'start' ? '0' : '3'),
        { 'visually-hidden': _vm.isLoading } ]}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }